export default "__VITE_ASSET__5120a18c__"